import {
  EMAIL_IFINANCE,
  ErrorPage,
  FilteredCreditApplication,
  Loader,
  PHONE_NUMBER_IFINANCE,
  PHONE_NUMBER_LINK_IFINANCE,
  PageSectionTitle as SectionTitle,
  useGetCreditApplicationById,
} from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { Trans, useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

interface Props {
  creditApp: FilteredCreditApplication
}

const FailedIdentification = ({ creditApp }: Props) => {
  const { t } = useTranslation()

  return (
    <main className="step-0">
      <SectionTitle title={t('identification.failed')} />
      <h1>{t('identification.explanation')}</h1>
      <Link className="btn btn-blue primary-action-btn" to={`/creditApplication/${creditApp.id}/vouched`} replace>
        <span>{t('identification.retryVerification')}</span>
        <i className="fa-regular fa-paper-plane-top" />
      </Link>
    </main>
  )
}

interface FailedIdentificationFinalPageProps {
  creditApp: FilteredCreditApplication
}

export const FailedIdentificationFinalPage = ({ creditApp }: FailedIdentificationFinalPageProps) => {
  const { t } = useTranslation()
  return (
    <ErrorPage
      title={t('identification.failed')}
      description={
        <>
          {t('identification.failedNoRetryDescription')}
          <br />
          <br />
          <h4>{t('identification.contactUs')}</h4>
          <Trans
            i18nKey="common.contactUs"
            values={{
              phoneNumber: PHONE_NUMBER_IFINANCE,
              email: EMAIL_IFINANCE,
            }}
            components={{
              phone: <Link to={PHONE_NUMBER_LINK_IFINANCE} style={{ textWrap: 'nowrap' }} />,
              email: (
                <Link
                  to={`mailto:${EMAIL_IFINANCE}?subject=${t('identification.needHelpSubject', { applicationNumber: creditApp.referenceNumber })}&body=${t('identification.needHelpBody', { applicationNumber: creditApp.referenceNumber })}`}
                  style={{ textWrap: 'nowrap' }}
                />
              ),
            }}
          />
        </>
      }
    />
  )
}

const FailedIdentificationPage = () => {
  const { id } = useParams()
  const [creditApp, loading] = useGetCreditApplicationById(id!, EFinancingProgram.B2c)

  if (loading) return <Loader />
  if (!creditApp) return <ErrorPage />
  const vouchedFailedCount = creditApp.applicant.vouchedFailedCount || 0
  if (vouchedFailedCount > 1) return <FailedIdentificationFinalPage creditApp={creditApp} />

  return <FailedIdentification creditApp={creditApp} />
}

export default FailedIdentificationPage
